<template>
  <div class="referral">
    <ContactTable />
  </div>
</template>
<script>
import ContactTable from "@/components/contact/ContactTable";
export default {
  components: { ContactTable },
};
</script>
